import keplerGlReducer from '@kepler.gl/reducers';

export const customizedKeplerGlReducer = keplerGlReducer.initialState({
    mapStyle: {
        styleType: 'dark',
    }
});